<template>
    <div>
        <div v-if="classScheduleData.length===0" class="alert alert-warning mb-0">没有教学安排数据</div>
        <table v-else class="table table-bordered mb-0">
            <thead>
            <tr>
                <th class="text-center align-middle" colspan="2">日期</th>
                <th class="text-center align-middle" style="width: 25%">课程名称</th>
                <th class="text-center align-middle" style="width: 30%">课程内容</th>
                <th class="text-center align-middle" style="width: 10%">讲师</th>
                <th class="text-center align-middle" style="width: 10%">课时</th>
                <th class="text-center align-middle" style="width: 10%">授课地点</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(schedule, index) in classScheduleData" :key="schedule.scheduleId">
                <td class="text-center align-middle" style="width: 10%">{{schedule.trainDateString}}</td>
                <td class="text-center align-middle" style="width: 5%">{{schedule.trainDatePartName}}</td>
                <td class="text-left align-middle">{{schedule.courseName}}</td>
                <td class="text-left align-middle">{{schedule.trainContent}}</td>
                <td class="text-center align-middle">{{schedule.personName}}</td>
                <td class="text-center align-middle">{{schedule.trainLength}}</td>
                <td class="text-center align-middle">{{schedule.classRoom}}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import projectApi from "@/utils/api/project";

export default {
    name: "ProjectClassScheduleView",
    props: {
        classId: {type: String, required: true},
    },
    data: function () {
        return {
            classScheduleData: [],
        };
    },
    mounted() {
        this.getClassScheduleData();
    },
    methods: {
        getClassScheduleData() {
            projectApi.class.schedule.getProjectClassScheduleData(this.classId).then(res => {
                this.classScheduleData = res.data;
            });
        },
    }
}
</script>

<style scoped>

</style>